import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NavHeader from './NavHeader';
import styles from './auto-login.module.css';

const AutoLogin = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = params.get('token');
        if (token) {
            localStorage.setItem('token', token);  // save token
            localStorage.setItem('notification', 'You have successfully logged in !'); // set notification
            navigate('/');                 // redirect to dashboard
        } else {
            navigate('/login');                     // fallback
        }
    }, []); 

    return (
        <>
            <NavHeader/>
            <br/><br/>
            <br/><br/>
            <p className={styles.message}>
                Hello! Logging you in automatically... If you are not redirected, please <a href="/login">click here</a>.
            </p>
        </>
    )
}

export default AutoLogin;